const refactorDiscounts = (response) => {
  const couponCanUsed =
    response[0].couponCanUsed

  if (!couponCanUsed) return []

  const foodDiscount =
    response[0].items.reduce((t, item) =>
      t += item.foodDiscount, 0
    ) || 0

  const deliveryDiscount =
    response[0].items.reduce((t, item) =>
      t += item.deliveryDiscount, 0
    ) || 0

  return [{
    couponCanUsed: true,
    foodDiscount,
    deliveryDiscount,
    items: response[0].items,
    couponCode: response[0].couponCode
  }]
}

export default refactorDiscounts